var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDotsSixVertical = function SvgIconDotsSixVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.125 5.625a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M16.875 5.625a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M8.625 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M16.875 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M8.625 19.875a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M16.875 18.375a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }))));
};
export default SvgIconDotsSixVertical;